import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { components } from 'react-select';

export const DropdownIndicator = props => {
  const {
    selectProps: { menuIsOpen },
  } = props;

  const iconStyle = {
    transition: 'transform 0.3s ease',
    transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <components.DropdownIndicator {...props}>
      <FaChevronDown style={iconStyle} />
    </components.DropdownIndicator>
  );
};

export const customStyles = {
  control: base => ({
    ...base,
    padding: '2px',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#58d0ff' : 'white',
    borderRadius: '6px',
    color: state.isFocused ? 'white' : 'black',
    padding: '10px 12px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
  menu: base => ({
    ...base,
    padding: '8px',
    zIndex: 9999,
    marginTop: 0,
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
};
